import { useCallback, useEffect, useState } from "react";

import { MonthSelector } from "../MonthSelector";
import { items } from "../MonthSelector/__items__";
import { Container } from "./styled";

export const MonthPeriodSelector = ({ onChange }) => {
  const [start, setStart] = useState();
  const [end, setEnd] = useState();

  const handleChange = useCallback(() => {
    if (start && end) {
      const startIndex = items.findIndex((item) => item.value === start);
      const endIndex = items.findIndex((item) => item.value === end);
      const step =
        endIndex >= startIndex
          ? endIndex - startIndex + 1
          : endIndex + (items.length - startIndex + 1);

      if (step <= 0) {
        onChange(undefined);
        setEnd(undefined);
      } else {
        onChange({
          start,
          step,
        });
      }
    } else {
      onChange(undefined);
    }
    // eslint-disable-next-line
  }, [start, end]);

  useEffect(() => {
    handleChange();
  }, [handleChange]);

  return (
    <Container>
      <MonthSelector placeholder="ماه شروع" value={start} onChange={setStart} />
      <MonthSelector
        placeholder="ماه پایان"
        value={end}
        onChange={setEnd}
        selectedStartMonth={start}
      />
    </Container>
  );
};
